import { render, staticRenderFns } from "./TariffAutLawyerItem.vue?vue&type=template&id=2a7b4db2&scoped=true&"
import script from "./TariffAutLawyerItem.vue?vue&type=script&lang=ts&"
export * from "./TariffAutLawyerItem.vue?vue&type=script&lang=ts&"
import style0 from "./TariffAutLawyerItem.vue?vue&type=style&index=0&id=2a7b4db2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7b4db2",
  null
  
)

export default component.exports